import { z } from 'zod';

import type {
  PatchAdminV1OrgStoresIdBody,
  SocialSettingsPinterest,
} from '@nucleus-commerce/api-client/admin';

const wholeNumberIn = (min: number, max: number, error: string) =>
  z
    .string()
    .trim()
    .refine((v) => /^\d+$/.test(v) && Number(v) >= min && Number(v) <= max, { error });

/** `settings.social.pinterest` as the form edits it; the bounds are the backend's. */
export const pinterestSettingsSchema = z.object({
  dailyCap: wholeNumberIn(1, 100, 'social:validation.dailyCap'),
  minSpacingMinutes: wholeNumberIn(0, 1440, 'social:validation.minSpacing'),
  utmTagging: z.boolean(),
  catalogProcessingTime: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, { error: 'social:validation.processingTime' }),
});

export type PinterestSettingsForm = z.infer<typeof pinterestSettingsSchema>;

export function fromPinterestSettings(settings: SocialSettingsPinterest): PinterestSettingsForm {
  return {
    dailyCap: String(settings.dailyCap),
    minSpacingMinutes: String(settings.minSpacingMinutes),
    utmTagging: settings.utmTagging,
    catalogProcessingTime: settings.catalogProcessingTime,
  };
}

/** The store PATCH merges `settings.social.pinterest` key by key. */
export function toPinterestSettingsPatch(
  values: PinterestSettingsForm,
): PatchAdminV1OrgStoresIdBody {
  return {
    settings: {
      social: {
        pinterest: {
          dailyCap: Number(values.dailyCap),
          minSpacingMinutes: Number(values.minSpacingMinutes),
          utmTagging: values.utmTagging,
          catalogProcessingTime: values.catalogProcessingTime,
        },
      },
    },
  };
}
